import ResolutionReasonsApi from '../../api/resolutionReasons';

const state = {
  records: [],
  isFetching: false,
  isFetched: false,
};

export const getters = {
  getActiveResolutionReasons: $state => $state.records,
  isFetchingResolutionReasons: $state => $state.isFetching,
};

export const actions = {
  async getActive({ commit, state: $state }) {
    if ($state.isFetching || $state.isFetched) return;

    commit('SET_FETCHING', true);
    try {
      const { data } = await ResolutionReasonsApi.getActive();
      commit('SET_RECORDS', data.payload || data);
    } catch (error) {
      // The modal remains usable once resolution reasons are available again.
    } finally {
      commit('SET_FETCHING', false);
    }
  },
};

export const mutations = {
  SET_FETCHING($state, isFetching) {
    $state.isFetching = isFetching;
  },
  SET_RECORDS($state, records) {
    $state.records = records;
    $state.isFetched = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
